<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

defineOptions({
    inheritAttrs: false,
});

type Props = {
    className?: HTMLAttributes['class'];
    accent?: string;
};

const props = withDefaults(defineProps<Props>(), {
    accent: '#3B5BDB',
});

const uid = Math.random().toString(36).slice(2, 8);
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 120"
        fill="none"
        :class="className"
        v-bind="$attrs"
    >
        <defs>
            <clipPath :id="`clip-${uid}`">
                <path d="M50 4 C 50 4 12 50 12 72 A 38 38 0 1 0 88 72 C 88 50 50 4 50 4 Z" />
            </clipPath>
            <mask :id="`mask-${uid}`" maskContentUnits="userSpaceOnUse">
                <path d="M50 4 C 50 4 12 50 12 72 A 38 38 0 1 0 88 72 C 88 50 50 4 50 4 Z" fill="white" />
                <g transform="translate(38 52) scale(0.4)">
                    <rect x="0" y="0" width="14" height="68" fill="black" />
                    <rect x="46" y="0" width="14" height="68" fill="black" />
                    <path d="M14 0 L60 68 L46 68 L0 0 Z" fill="black" />
                </g>
            </mask>
        </defs>
        <g :mask="`url(#mask-${uid})`">
            <path d="M50 4 C 50 4 12 50 12 72 A 38 38 0 1 0 88 72 C 88 50 50 4 50 4 Z" fill="currentColor" />
            <g :clip-path="`url(#clip-${uid})`">
                <rect x="0" y="98" width="100" height="22" :fill="props.accent" />
            </g>
        </g>
    </svg>
</template>
